// components
import { DatePicker as MuiDatePicker } from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

/**
 * @component DatePicker
 */
moment.locale('en',{
  weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
  // week:{
  //   dow: 1
  // }
})
function DatePicker({ DialogProps, calendarType, ...rest }) {
  return calendarType === 'gregorian' ? (
    <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
      <MuiDatePicker
        DialogProps={{ ...DialogProps,dir:"ltr", container: document.getElementById('portal') }}
        {...rest}
      />
    </MuiPickersUtilsProvider>
  ) : (
    <MuiDatePicker
      DialogProps={{ ...DialogProps, container: document.getElementById('portal') }}
      {...rest}
    />
  );
}

export default DatePicker;
